import React from 'react';
import FleetReports from './Reports';
import Events from 'APP_ROOT/components/common/events';
import Protected from 'APP_ROOT/components/common/protected';

export default class Reports extends React.Component {

    constructor (props) {

        super(props);

        this.state = {
            userDataLoaded: false
        }
    }

    componentDidMount () {
        if (!this.props.ravens) {
            this.props.getUserData(this.onUserDataLoaded);
        } else {
            this.onUserDataLoaded();
        }
    }

    onUserDataLoaded = () => {
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.setState({
            userDataLoaded: true
        });
    }

    render () {
        if (!this.state.userDataLoaded || !this.props.user) {
            return null;
        }

        const { features } = this.props;
        if (!features) {
            console.error("Reports index render with invalid features prop.");
            return null;
        }
        if (!features.hasOwnProperty("fleet_reports")) {
            console.warn("Reports index render with incomplete features, fleet_reports not defined (race condition?)");
            return null;
        }

        return (
            <Protected resource="reports" action="view" gate={features.fleet_reports} showNotFound>
                <FleetReports {...this.props} />
            </Protected>
        );
    }
}
